import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular'
@Component({
  selector: 'app-vendor-tc',
  templateUrl: './vendor-tc.component.html',
  styleUrls: ['./vendor-tc.component.scss'],
})
export class VendorTCComponent implements OnInit {
  tcData: any;
  constructor(public ModalCtrl: ModalController, public NavParams: NavParams) {
    debugger;

    this.tcData = NavParams.get("data");
    let html = this.tcData[0].tc_value;
    let div = document.createElement("div");
    div.innerHTML = html;
    let text = div.textContent || div.innerText || "";
    this.tcData[0].tc_value = text
  }
  ngOnInit() { }


  closemodel() {
    this.ModalCtrl.dismiss();
    this.tcData = [];
  }

}
